import { useTranslation } from 'react-i18next'
import CertificationForm from '../common/CertificationForm'
import useCertificationAddPage from './hooks/useCertificationAddPage'

export default function CertificationAdd() {
	const { t } = useTranslation()
	const { handleCancel, handleSubmit, submitting } = useCertificationAddPage()

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('trainingCertifications.add.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
						<CertificationForm
							mode="add"
							onSubmit={handleSubmit}
							onCancel={handleCancel}
							submitting={submitting}
						/>
				</div>
			</div>
		</div>
	)
}
